import React, { useEffect, useRef, useState, useCallback } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import { getRandomNumberInRange, getUrl } from "../../../MIS/Global";
import axios from "axios";
import CategoryCard from "../Cards/CategoryCard";
import { useParams } from "react-router-dom";
import { FaBoxOpen } from "react-icons/fa";
import { FaThLarge, FaTh} from 'react-icons/fa'; 
import AppNavBarSearch from "../../pages/AppNavBarSearch";
import TbkProductPageScrollLoad from "../Products/TbkProductPageScrollLoad";
import PageHistory from "../../GlobalComponent/PageHistory";
import { decrypt, encrypt } from "../../../MIS/encryption";

const UserSubCategoryPageLoad = () => {
  // const { mpid:decrypt(mpid) ,mpname} = useParams();
  let { mpid, mpname } = useParams();
  mpid = decrypt(mpid)
  const [lastId, setLastId] = useState(0);
  const [limit] = useState(getRandomNumberInRange(25, 40));
  const [subProducts, setSubProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // Prevent unnecessary calls
  const [isSingleColumn, setIsSingleColumn] = useState(true);
  const [isSearch, setIsSearch] = useState(false);
  const [searchString, setSearchString] = useState("");
  const observer = useRef(null);

  const toggleColumn = () => {
    setIsSingleColumn((prev) => !prev);
  };
  const toggleSearch = () => {
    setIsSearch((prev) => !prev);
  };
  const apiClient = axios.create({
    baseURL: getUrl(),
    headers: { "Content-Type": "application/json" },
  });

  const fetchData = useCallback(async () => {
    if (isLoading || !hasMore) return; // Prevent multiple calls or if no more data
    setIsLoading(true);

    let data = { limit, mpid, id: lastId, action: "subproduct" };
    if (lastId <= 0) {
      data = { limit, mpid, action: "subproduct" };
    }

    try {
      const res = await apiClient.post("sub-product/", data);
      const newItems = res?.data?.data || [];      
      if (newItems.length > 0) {
        setSubProducts((prevItems) => {
          const uniqueItems = newItems.filter(
            (item) => !prevItems.some((prev) => prev.id === item.id)
          );
          return [...prevItems, ...uniqueItems]; // Append only unique items
        });

        setLastId(newItems[newItems.length - 1].id);
      } else {
        setHasMore(false); // Stop fetching when no new data
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [lastId, limit, mpid, isLoading, hasMore]);

  useEffect(() => {
    fetchData(); // Initial fetch
  }, [fetchData]);

  useEffect(() => {
    if (observer.current) observer.current.disconnect(); // Disconnect previous observer

    observer.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isLoading) {
          fetchData(); // Load more data when last item is in view
        }
      },
      { threshold: 1.0 }
    );

    const lastElement = document.querySelector(".last-item");
    if (lastElement) {
      observer.current.observe(lastElement);
    }

    return () => observer.current?.disconnect();
  }, [fetchData, isLoading]);
  const breadcrumbData = [
    { label: mpname, path: "/category" },
    { label: "Sub Products", path: "/products" },    
  ];
  
  return (
    <Container className='h-full mb-2'>      
      {!isSearch && (
        <>
       <Row  className="pt-1"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          // width: "100%",
          // borderBottom: "1px solid #ddd",
        }}       
       >
       
        <Col xs={8} md={12}>
          <PageHistory history={breadcrumbData} />
          {/* <h6>Showing all ({subProducts.length}) results</h6> */}
        </Col>
        <Col xs={4}>
        <div
          className="d-sm-none mb-3 d-flex justify-content-end align-content-center pt-1"
          onClick={toggleColumn}
          style={{ textAlign: 'right', cursor: 'pointer' }}
        >
        {isSingleColumn ? <FaThLarge size={24} /> : <FaTh size={24} />}
       
      </div>
        </Col>
      </Row>
      <div style={{ overflowY: "auto", height: "calc(100vh - 80px)", paddingTop: "10px" }}>
       {subProducts.length === 0 && !isLoading && !hasMore && (
        <Row className="d-flex justify-content-center align-items-center text-center" style={{ height: "50vh" }}>
          <Col xs={12}>
            <FaBoxOpen size={50} color="#ff6b6b" />
            <h4 style={{ color: "#555", marginTop: "10px" }}>No Products Found</h4>
            <p style={{ color: "#777" }}>Try a different category or check back later.</p>
          </Col>
        </Row>
      )}
      <Row className="d-flex justify-content-center align-items-center gx-1 gy-1 gx-md-3 gy-md-3">
        {subProducts?.sort((a, b) => a.seqno - b.seqno)?.map((element, index) => (
          <Col
            key={element.id}
            xs={isSingleColumn ? 12 : 6}
            sm={isSingleColumn ? 12 : 6}
            md={4}
            lg={4}
            className={index === subProducts.length - 1 ? "last-item" : ""}
          >
            <CategoryCard product={element} 
             path={`/tbk/${encrypt(element.id)}`}
             isShare={true}
             />
          </Col>
        ))}

        {isLoading && hasMore && (
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </Col>
        )}
      </Row>
      </div>
      </>
      )}
    </Container>
  );
};

export default UserSubCategoryPageLoad;
